import { Ruler } from "lucide-react";
import { PRINT_HEIGHTS } from "../lib/api";

export const PrintSizePicker = ({ value, onChange }) => (
  <div data-testid="print-size-picker" className="rounded-3xl border border-border bg-card/60 p-4">
    <p className="flex items-center gap-2 text-xs font-mono2 uppercase tracking-widest text-muted-foreground mb-3">
      <Ruler className="h-4 w-4" /> Print height
    </p>
    <div className="grid grid-cols-4 gap-2">
      {PRINT_HEIGHTS.map((h) => (
        <button
          key={h}
          data-testid={`print-size-${h}`}
          aria-pressed={value === h}
          onClick={() => onChange(h)}
          className={`rounded-full py-2 text-sm font-semibold border transition-colors ${
            value === h ? "bg-primary text-primary-foreground border-primary" : "bg-background border-border hover:border-primary"
          }`}
        >
          {h} mm
        </button>
      ))}
    </div>
  </div>
);
